import { OnRaceBetsSchema } from './OnRaceBets.styles';

export const onRaceBetStyles: OnRaceBetsSchema = {
  betsAndViewMoreButtonWrapper: {
    borderX: '2px',
    borderBottom: '2px',
    borderColor: 'beta.400',
    borderBottomRadius: 'lg',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.35),0px 0px 0px 2px #000 inset',
    p: 3,
    zIndex: 1,
    marginTop: -0.5,
  },
  betsContainer: { flexDirection: 'column' },
  wrapper: {
    border: 'none',
    mb: '2',
    bg: 'white',
    borderRadius: 'lg',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  headerWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    bgGradient: 'linear(to-b, alpha.600, alpha.800)',
    borderTopRadius: 'lg',
    py: 2,
    px: 3,
    color: 'white',
    zIndex: 2,
  },
  headerText: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: 'white',
    textTransform: 'lowercase',
    sx: {
      '&:first-letter': {
        textTransform: 'capitalize',
      },
    },
  },
  headerCountText: {
    ml: '1',
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'white',
  },
  headerExpandButton: {
    variant: 'primary',
    ml: 'auto',
    boxSize: '6',
    minW: 6,
    p: 0,
  },
  toggleIcon: {
    boxSize: '6',
    color: 'white',
  },
  betCategoryWrapper: {
    alignItems: 'center',
    mt: '2',
  },
  betCategory: {
    fontSize: 'sm',
    fontWeight: 'semibold',
    color: 'alpha.700',
  },
  betCategoryCount: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'alpha.700',
    ml: '1',
  },
  divider: {
    borderWidth: 'px',
    opacity: '1',
    borderColor: 'blackAlpha.400',
    mt: '1.5',
  },
  betRow: {
    bg: 'alpha.50',
    gap: '1',
    p: 2,
    borderRadius: 'lg',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  },
  betRowDivider: {
    bg: 'alpha.50',
    p: 2,
    borderRadius: 'lg',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
  },
  groupDivider: {
    borderBottomWidth: '1px',
    borderBottomColor: 'blackAlpha.400',
  },
  categoryIcon: {
    color: 'beta.400',
    boxSize: '5',
  },
  groupContainer: {
    flexDir: 'column',
    py: 2,
    borderBottomWidth: '0px',
    gap: 1,
  },
  groupTitleText: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  runnerText: {
    color: 'gray.700',
    fontSize: 'sm',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  runnerBarrierText: {
    color: 'gray.700',
    fontSize: 'xs',
  },
  stakeText: {
    color: 'beta.500',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  potentialWinningsText: {
    color: 'beta.500',
    fontSize: 'xs',
    fontWeight: 'black',
  },
  subtitleText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  exoticsPositionText: {
    color: 'gray.700',
    fontSize: 'xs',
    fontWeight: 'bold',
    w: 9,
  },
  viewMoreButton: {
    variant: 'solid',
    _hover: {
      _after: {
        bg: 'gamma.600',
        borderRadius: 'md',
      },
    },
  },
  viewMoreButtonText: {
    fontSize: 'sm',
    textTransform: 'uppercase',
  },
  srmBlendedLegContainer: {
    flexDir: 'row',
    flex: '1',
  },
  srmBlendedRunnerText: {
    width: 32,
    fontWeight: 'bold',
    color: 'gray.700',
    fontSize: 'xs',
    textTransform: 'capitalize',
  },
  srmMarketText: {
    fontWeight: 'bold',
    color: 'gray.700',
    fontSize: 'xs',
  },
  srmBlendedWrapper: {
    flexDir: 'column',
    flex: 1,
  },
  flexiText: {
    fontWeight: 'bold',
    color: 'gray.600',
    fontSize: 'xs',
  },
  flexiStakeText: {
    width: '16',
    color: 'gray.700',
    fontWeight: 'bold',
  },
  flexiStakeValueText: {
    color: 'alpha.400',
    fontWeight: 'bold',
  },
};
